export type ChipStatus = "draft" | "scheduled" | "published" | "hidden" | "available" | "sold-out";

const LABEL: Record<ChipStatus, string> = { draft: "Draft", scheduled: "Scheduled", published: "Published", hidden: "Hidden", available: "Available", "sold-out": "Sold out" };

/** One pill for every status in the builder: posts (draft, scheduled, published) and products (hidden, available, sold out). */
export function StatusChip({ status }: { status: ChipStatus }) {
  return <span className="bw-area-chip" data-status={status}>{LABEL[status]}</span>;
}
